const THROW_ON_BOT_ERROR = true

export default function throwOnBotError(err : unknown) {
  if (THROW_ON_BOT_ERROR) {
    throw err
  }
}